import {
	IGetSubCategoriesArguments,
	ICreateSubCategory,
	ICreateSubcategoryV2,
	IUpdateSubCategory,
	IUpdateSubcategoryV2,
	IGetPaginatedSubCategories,
	IGetPaginatedSubcategoriesByCustomerV2,
	IGetPaginatedSubcategoriesByRestaurantV2,
	IGetSubCategoryPositionListArguments,
	IGetSubCategoryPositionChainsArguments,
	IUpdateSubCategoryPositions,
	IGetSubcategoryRestaurantPropertiesArguments,
	IUpdateSubcategoryRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForSubcategory,
} from 'types';
import {
	serviceGetSubCategoryInfo,
	serviceGetSubcategoryInfoV2,
	serviceGetSubCategoriesShort,
	serviceGetSubCategoriesShortV2,
	serviceCreateSubCategory,
	serviceCreateSubcategoryV2,
	serviceUpdateSubCategory,
	serviceUpdateSubCategoryV2,
	serviceGetPaginatedSubCategories,
	serviceGetPaginatedSubcategoriesByCustomerV2,
	serviceGetPaginatedSubcategoriesByRestaurantV2,
	serviceDeleteSubCategory,
	serviceDeleteSubcategoryV2,
	serviceGetSubCategoryPositionList,
	serviceGetSubcategoryPositionListV2,
	serviceGetSubCategoryPositionChains,
	serviceGetSubCategoryPositionChainsV2,
	serviceUpdateSubCategoryPositions,
	serviceUpdateSubCategoryPositionsV2,
	serviceGetSubcategoryRestaurantProperties,
	serviceUpdateSubcategoryRestaurantProperties,
	serviceUpdateSubcategoryRestaurantPropertiesAsPatch,
	serviceUpdateRestaurantsInSubcategory,
	serviceUpdateDishesInSubcategory,
	serviceGetSubcategoryPhotos,
} from 'services/api/subcategories';
import { createAppErrorMessage } from 'utils/helpers';

// Menu v1
const getSubCategoryInfo = async (subCategoryID: string) => {
	try {
		const response = await serviceGetSubCategoryInfo(subCategoryID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getSubcategoryInfoV2 = async (subcategoryID: string) => {
	try {
		const response = await serviceGetSubcategoryInfoV2(subcategoryID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getSubCategoriesShortInfo = async (categoryIds: string[]) => {
	try {
		const response = await serviceGetSubCategoriesShort(categoryIds);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getSubCategoriesShortInfoV2 = async (args: IGetSubCategoriesArguments) => {
	try {
		const response = await serviceGetSubCategoriesShortV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const createSubCategory = async (data: ICreateSubCategory) => {
	try {
		await serviceCreateSubCategory(data);
	} catch (err) {
		throw err;
	}
};
// Menu v1
// Menu v2
const createSubcategoryV2 = async (data: ICreateSubcategoryV2) => {
	try {
		const response = await serviceCreateSubcategoryV2(data);
		return response;
	} catch (err) {
		throw err;
	}
};
// Menu v2

// Menu v1
const updateSubCategory = async (data: IUpdateSubCategory) => {
	try {
		await serviceUpdateSubCategory(data);
	} catch (err) {
		throw err;
	}
};
// Menu v1
// Menu v2
const updateSubCategoryV2 = async (data: IUpdateSubcategoryV2) => {
	try {
		await serviceUpdateSubCategoryV2(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingSubcategory');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getPaginatedSubCategories = async (args: IGetPaginatedSubCategories) => {
	try {
		const response = await serviceGetPaginatedSubCategories(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getPaginatedSubcategoriesByCustomerV2 = async (args: IGetPaginatedSubcategoriesByCustomerV2) => {
	try {
		const response = await serviceGetPaginatedSubcategoriesByCustomerV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getPaginatedSubcategoriesByRestaurantV2 = async (args: IGetPaginatedSubcategoriesByRestaurantV2) => {
	try {
		const response = await serviceGetPaginatedSubcategoriesByRestaurantV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const deleteSubCategory = async (subCategoryID: string) => {
	try {
		await serviceDeleteSubCategory(subCategoryID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingSubcategory');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const deleteSubcategoryV2 = async (subcategoryID: string) => {
	try {
		await serviceDeleteSubcategoryV2(subcategoryID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingSubcategory');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getSubCategoryPositionList = async (args: IGetSubCategoryPositionListArguments) => {
	try {
		const response = await serviceGetSubCategoryPositionList(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getSubCategoryPositionListV2 = async (args: IGetSubCategoryPositionListArguments) => {
	try {
		const response = await serviceGetSubcategoryPositionListV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getSubCategoryPositionChains = async (args: IGetSubCategoryPositionChainsArguments) => {
	try {
		const response = await serviceGetSubCategoryPositionChains(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getSubCategoryPositionChainsV2 = async (args: IGetSubCategoryPositionChainsArguments) => {
	try {
		const response = await serviceGetSubCategoryPositionChainsV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const updateSubCategoryPositions = async (data: IUpdateSubCategoryPositions) => {
	try {
		await serviceUpdateSubCategoryPositions(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingSubcategoryPositions');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const updateSubCategoryPositionsV2 = async (data: IUpdateSubCategoryPositions) => {
	try {
		await serviceUpdateSubCategoryPositionsV2(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingSubcategoryPositions');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getSubcategoryRestaurantProperties = async (args: IGetSubcategoryRestaurantPropertiesArguments) => {
	try {
		const response = await serviceGetSubcategoryRestaurantProperties(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateSubcategoryRestaurantProperties = async (data: IUpdateSubcategoryRestaurantProperties) => {
	try {
		await serviceUpdateSubcategoryRestaurantProperties(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurantProperties');
		throw new Error(errorMessage);
	}
};

const updateSubcategoryRestaurantPropertiesAsPatch = async (data: IUpdateRestaurantPropertiesAsPatchForSubcategory) => {
	try {
		await serviceUpdateSubcategoryRestaurantPropertiesAsPatch(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurantPropertiesAsPatch');
		throw new Error(errorMessage);
	}
};

const updateRestaurantsInSubcategory = async (data: { subcategoryId: string; restaurantIds: string[] }) => {
	try {
		await serviceUpdateRestaurantsInSubcategory(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurant');
		throw new Error(errorMessage);
	}
};

const updateDishesInSubcategory = async (data: { subCategoryId: string; restaurantId: string; dishIds: string[] }) => {
	try {
		await serviceUpdateDishesInSubcategory(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingDishesInSubcategory');
		throw new Error(errorMessage);
	}
};

const getSubcategoryPhotos = async (args: { subCategoryIds: string[]; size: 1 | 2 | 3 }) => {
	try {
		const response = await serviceGetSubcategoryPhotos(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

export {
	getSubCategoryInfo,
	getSubcategoryInfoV2,
	getSubCategoriesShortInfo,
	getSubCategoriesShortInfoV2,
	createSubCategory,
	createSubcategoryV2,
	updateSubCategory,
	updateSubCategoryV2,
	getPaginatedSubCategories,
	getPaginatedSubcategoriesByCustomerV2,
	getPaginatedSubcategoriesByRestaurantV2,
	deleteSubCategory,
	deleteSubcategoryV2,
	getSubCategoryPositionList,
	getSubCategoryPositionListV2,
	getSubCategoryPositionChains,
	getSubCategoryPositionChainsV2,
	updateSubCategoryPositions,
	updateSubCategoryPositionsV2,
	getSubcategoryRestaurantProperties,
	updateSubcategoryRestaurantProperties,
	updateSubcategoryRestaurantPropertiesAsPatch,
	updateRestaurantsInSubcategory,
	updateDishesInSubcategory,
	getSubcategoryPhotos,
};
